import { useEffect, useState } from 'react';
import { useOutsideFrameMessenger, useInsideFrameMessenger, simpleStateSetHandler } from './messengerHooks';
const heightMessageKey = 'syncHeight';
const syncIFrameHeightHandlers = {
  [heightMessageKey]: simpleStateSetHandler
};
export const useSyncIFrameHeight = () => {
  const {
    state,
    registerIFrame
  } = useOutsideFrameMessenger({
    key: 'syncHeight',
    messageHandlers: syncIFrameHeightHandlers
  });
  return {
    registerIFrame,
    height: state === null || state === void 0 ? void 0 : state.height
  };
};
export const useSyncIFrameHeightInsideFrame = ref => {
  const [isReady, setIsReady] = useState(false);
  const {
    sendMessage
  } = useInsideFrameMessenger({
    allowExternal: true,
    key: 'syncHeight',
    messageHandlers: {
      ['ready']: () => {
        var _ref$current;
        setIsReady(true);
        sendMessage(heightMessageKey, {
          height: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight
        }, true);
      }
    }
  });
  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry && sendMessage) {
        const height = entry.contentRect.height;
        sendMessage(heightMessageKey, {
          height
        }, true);
      }
    });
    if (ref !== null && ref !== void 0 && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref, sendMessage]);
  return {
    isReady
  };
};